import type { ProjectType } from '@atlassian/jira-common-constants';
import { ff } from '@atlassian/jira-feature-flagging';
import { fg } from '@atlassian/jira-feature-gating';
import { ASANA } from '../../../constants/import-type';
import { ProjectTypes } from '../../../constants/project';
import {
	DEFAULT_CONFIG,
	type StepComponent,
	UPLOAD_CSV_STEP,
	IMPORT_IN_PROGRESS_STEP,
	PROJECT_CREATE_STEP,
	SELECT_THIRD_PARTY_ENTITY_STEP,
	StatisticsType,
	THIRD_PARTY_REVIEW_STEP,
	ReviewTilesType,
	SELECT_SOURCE_STEP,
	templatesJSW,
} from '../../../constants/steps';
import commonMessages from '../messages';
import messages from './messages';

export const getAsanaSteps = (
	isSiteAdmin?: boolean,
	projectType?: ProjectType,
): StepComponent[] => [
	{
		step: SELECT_THIRD_PARTY_ENTITY_STEP,
		overrides: {
			overrideReturnStep: fg('enable-x2c-standardised-flow') ? SELECT_SOURCE_STEP : UPLOAD_CSV_STEP,
		},
		stepProps: {
			thirdParty: ASANA,
			stats:
				ff('gun-2207-non-admin-support-in-tmp-migration_k7z9p') && !isSiteAdmin
					? [StatisticsType.TASKS]
					: [StatisticsType.TASKS, StatisticsType.MEMBERS],
			hasSearchableEntities: true,
		},
		progressBarStepLabel: messages.asanaStepLabel,
	},
	{
		...DEFAULT_CONFIG,
		step: PROJECT_CREATE_STEP,
		stepProps: {
			hasProgressBar: true,
			shouldPrefillThirdPartyProjectName: true,
			shouldShowThirdPartyStats: false,
			thirdParty: ASANA,
			shouldStartImportOnNext: false,
			isTMPSupported: true,
			templates:
				projectType === ProjectTypes.SOFTWARE || fg('enable-x2c-standardised-flow')
					? templatesJSW
					: [],
		},
		progressBarStepLabel: commonMessages.projectCreateStepLabel,
	},
	{
		...DEFAULT_CONFIG,
		step: THIRD_PARTY_REVIEW_STEP,
		stepProps: {
			thirdParty: ASANA,
			tiles:
				ff('gun-2207-non-admin-support-in-tmp-migration_k7z9p') && !isSiteAdmin
					? [ReviewTilesType.HIERARCHY, ReviewTilesType.FIELDS, ReviewTilesType.ATTACHMENTS]
					: [
							ReviewTilesType.HIERARCHY,
							ReviewTilesType.FIELDS,
							ReviewTilesType.USERS,
							ReviewTilesType.ATTACHMENTS,
						],
		},
		progressBarStepLabel: commonMessages.reviewStepLabel,
	},
	{
		step: IMPORT_IN_PROGRESS_STEP,
		overrides: {
			overrideReturnStep: fg('enable-x2c-standardised-flow') ? SELECT_SOURCE_STEP : UPLOAD_CSV_STEP,
		},
		stepProps: {
			hasProgressBar: true,
			thirdParty: ASANA,
		},
		progressBarStepLabel: commonMessages.importInProgressStepLabel,
	},
];
